module.exports = __webpack_public_path__ + "static/img/appdow_bk4_icon.41f7fab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_bk4_icon.png
// module id = 0y0H
// module chunks = 4